import { HelpCircle, Plus } from "lucide-react";

export default function Faq() {
  const items = [
    ["How do bookings work?", "Choose a program, pick your date, share school & teacher details. We confirm within 24 hours."],
    ["Are trainings on-site or online?", "Both. Every program can be delivered on-site at your school, online, or hybrid."],
    ["How are certificates issued?", "After each program, teachers receive PDF certificates with a QR-verified public URL."],
    ["Can we import our teacher list?", "Yes — CSV or Excel with columns name, email, subject, phone."],
    ["What's the minimum cohort size?", "10 teachers. We craft the best experience for cohorts between 15 and 60."],
  ];

  return (
    <div style={{ backgroundColor: "#F8FAFC" }}>
      <div className="max-w-3xl mx-auto px-5 sm:px-6 py-20 sm:py-24">
        <div className="fade-up text-center">
          <div
            className="w-12 h-12 rounded-full grid place-items-center mx-auto mb-5"
            style={{ backgroundColor: "#3B68E714" }}
          >
            <HelpCircle className="w-5 h-5" style={{ color: "#3B68E7" }} aria-hidden="true" />
          </div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold mb-3" style={{ color: "#3B68E7" }}>FAQ</div>
          <h1
            className="rebrand-serif font-bold tracking-tight"
            style={{ fontSize: "clamp(2.25rem, 3vw + 1rem, 3rem)", color: "#1A202C" }}
          >
            Everything, briefly.
          </h1>
        </div>

        <div className="mt-12 space-y-4">
          {items.map(([q, a], i) => (
            <details
              key={i}
              className="group bg-white transition-shadow duration-300"
              style={{ borderRadius: 24, border: "1px solid #E2E8F0", boxShadow: "0 10px 25px rgba(0,0,0,0.05)" }}
              data-testid={`faq-${i}`}
            >
              <summary
                className="cursor-pointer font-semibold text-base list-none flex justify-between items-center gap-4 px-6 py-5"
                style={{ color: "#1A202C" }}
              >
                {q}
                <span
                  className="shrink-0 w-8 h-8 rounded-full grid place-items-center transition-transform duration-200 group-open:rotate-45"
                  style={{ backgroundColor: "#3B68E714" }}
                >
                  <Plus className="w-4 h-4" style={{ color: "#3B68E7" }} aria-hidden="true" />
                </span>
              </summary>
              <p className="px-6 pb-5 text-sm leading-relaxed" style={{ color: "#64748B", lineHeight: 1.6 }}>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
}
